import { getRelativeBasePath } from '../../global/environments/path'
import { encodeForURL } from '../../global/formatters/string-formatter'

export function init() {
  const urlParams = new URLSearchParams(window.location.search)
  const url = encodeForURL(urlParams.get('url'))

  if (url) {
    setTimeout(() => {
      // make sure we only redirect to internal pages
      if (url.indexOf('/') === 0 && url.indexOf('//') !== 0) {
        window.location.href = url
      } else {
        // if they give a full url, truncate it, and grab the path, if it fails, just go to the homepage
        try {
          const absoluteUrl = new URL(url)
          window.location.href = absoluteUrl.pathname
        } catch (error) {
          window.location.href = getRelativeBasePath() || '/'
        }
      }
    }, 3500)
  }
}

init()
